import { Stack } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";

type QAWrapperProps = React.ComponentProps<"div">;

export const QAWrapper = ({ children, className }: QAWrapperProps) => {
  const componentColors = useSelector(
    (state: RootState) => state.theme.componentColors,
  );

  return (
    <Stack
      sx={{
        backgroundColor: componentColors.surface.surfContainerHigh,
      }}
      className={`p-6 rounded-[1.75rem] my-10 lg:my-20 transition-all ${className}`}
    >
      {children}
    </Stack>
  );
};
